import "./App.css";
import About from "./Componants/About";
import Navbar from "./Componants/Navbar";
import TextInputForm from "./Componants/TextInputForm";

function App() {
  return (
    <>
      <Navbar tittle="CaseConverter" />
      <div className="container my-5">
        <h1>Enter the text to analyze</h1>
        <TextInputForm></TextInputForm>
      </div>{" "}
    </>
  );
}

export default App;


// import About from "./Componants/About";
// import Navbar from "./Componants/Navbar";

// function App() {
//   return (
//     <>
//       <Navbar tittle="CaseConverter" />

//       <div className="container my-5 mx-5 py-5 px-5">
//         <h1>About Us</h1>
//         <About></About>
//       </div>
//     </>
//   );
// }

// export default App;
